export default __webpack_public_path__ + "static/media/Dashboard.fadc2fcd.svg";